var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"menu-item",class:_vm.classNames,attrs:{"index":_vm.index},on:{"click":_vm.handleClick}},[_c('div',{class:['menu-item__content', {'is_subitem' : _vm.isSubItem}]},[_vm._t("icon"),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }